<template>
	<basic-container v-loading="!isShowContent" :block="!isShowContent || allDataList.length === 0">
		<div v-if="systemMessage" class="u-m-b-10">
			<el-alert :closable="false" :title="systemMessage" type="warning"></el-alert>
		</div>
		<div v-if="envConfig.isBxIe()" class="select_content u-m-b-20">
			<div
				v-for="(itemData, indexContent) in selectContentList"
				:key="indexContent"
				class="u-flex u-col-center u-row-left select_content_item_row">
				<span class="select_content_item_row_title">{{ itemData.title }}</span>
				<div>
					<el-checkbox-group v-model="selectDataList[`${itemData.key}`]">
						<el-checkbox
							v-for="(itemBox, index) in itemData.selectLabelList"
							:key="index"
							:label="itemBox.value"
							style="width: 90px">
							{{ itemBox.label }}
						</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</div>
		<div v-if="isShowContent">
			<div v-if="allDataList.length > 0">
				<div v-for="{dataList = [], type: productType = ''} in allDataList" :key="productType">
					<div v-if="isShowTitle" class="title u-flex u-col-center">
						<el-divider class="u-m-l-1 u-m-r-10 title-shu" direction="vertical"></el-divider>
						<span class="u-font-weight-bold u-font-md">{{ productType === '1' ? '我的收藏' : '全部产品' }}</span>
					</div>
					<draggable
						v-if="dataList.length > 0"
						v-model="dataList"
						:disabled="productType === '0'"
						animation="200"
						group="people"
						@end="onEnd"
						@start="onStart">
						<transition-group class="u-flex u-flex-wrap u-row-between product_content">
							<div v-for="(itemData, indexNei) in dataList" :key="itemData.id">
								<el-card :body-style="{padding: 0}" class="product_content_item" @click.native="handleView(itemData)">
									<el-image :src="itemData.picture || itemData.groupLogo" class="product_content_item_img" fit="fill" />
									<!--收藏-->
									<div class="product_content_item_collect u-relative" @click.stop="onCollect(itemData)">
										<el-icon
											:class="[getCollectIconStyle(productType)[0], `icon${indexNei}`]"
											:style="getCollectIconStyle(productType)[1]"
											style="color: #409eff"></el-icon>
									</div>
									<div
										:style="{color: itemData.color ? itemData.color : ''}"
										class="u-flex u-row-center product_content_item_control">
										<span class="product_content_item_text" @click.stop="onDownloadCategory(itemData)">
											<i :class="isDownLoading ? 'el-icon-loading' : 'el-icon-download'" class="u-m-r-5"></i>
											职业类别表
										</span>
										<el-divider class="u-m-l-15 u-m-r-15" direction="vertical"></el-divider>
										<span class="product_content_item_text" @click.stop="onCreatePlan(itemData)">
											<i class="el-icon-notebook-2 u-m-r-5"></i>
											投保计划书
										</span>
									</div>
									<div class="product_content_item_des">
										<div
											v-for="(item2, index2) in itemData.intros"
											:key="index2"
											class="product_content_item_des_content">
											{{ item2 }}
										</div>
									</div>
									<div v-if="isMainChannel()" class="product_content_item_fee" @click.stop="onShowFeeDetail">
										<el-popover :close-delay="100" placement="top" trigger="hover">
											<el-table :data="itemData.feeContentList" border>
												<el-table-column label="方案" property="label" width="240"></el-table-column>
												<el-table-column label="费率" property="value" width="60"></el-table-column>
											</el-table>
											<div slot="reference">
												<span v-if="itemData.feeContent" class="u-font-weight-bold">费用:</span>
												{{ itemData.feeContentList && itemData.feeContentList.length > 1 ? '最高 ' : ''
												}}{{ itemData.feeContent }}
												<el-icon
													v-if="itemData.feeContentList && itemData.feeContentList.length > 1"
													class="el-icon-arrow-right"></el-icon>
											</div>
										</el-popover>
									</div>
									<div class="u-flex u-row-between u-col-center u-m-b-10 product_content_item_insure">
										<div class="u-font-weight-bold product_content_item_insure_price">{{ itemData.price / 100 }}</div>
										<div>
											<el-button
												v-if="!isRenBao(itemData.insureType) || isFxadminChannel()"
												:loading="isInsureLoading"
												class="product_content_item_insure_to"
												type="primary"
												@click.stop="handleInsure(itemData)">
												去投保
											</el-button>
											<el-button-group v-else>
												<el-button
													:loading="isShareLoading"
													class="product_content_item_insure_to"
													type="primary"
													@click.stop="onToTransmit(itemData)">
													转发
												</el-button>
												<el-button
													:loading="isInsureLoading"
													class="product_content_item_insure_to"
													type="primary"
													@click.stop="handleInsure(itemData)">
													去投保
												</el-button>
											</el-button-group>
										</div>
									</div>
								</el-card>
							</div>
							<div v-for="n in 10" :key="n" class="product_content_item" style="height: 0; margin-top: 15px"></div>
						</transition-group>
					</draggable>
				</div>
			</div>
			<el-empty v-else class="u-m-t-60" description="数据为空"></el-empty>
		</div>
		<!--投保前的弹窗-->
		<insure-notices ref="refInsureNotices" @onToInsure="onGoInsure"></insure-notices>
		<!--小程序二维码-->
		<el-dialog :visible.sync="isShowQrCode" center custom-class="share_dialog" width="400px">
			<div class="u-flex-col u-col-center">
				<span class="u-font-weight-bold u-font-18 u-m-t-60" style="color: black">分享给他人录单</span>
				<span class="u-m-t-10">录单成功后，下载发票等操作</span>
				<span class="u-m-b-20">将在你的登录账号下进行</span>
				<img :src="qrCodeUrl" alt="" height="320" width="320" />
				<el-button class="u-m-t-30" plain type="primary" @click="onSaveWxMa">保存二维码图片</el-button>
			</div>
		</el-dialog>
	</basic-container>
</template>

<script>
import {
	collectProduct,
	collectProductSort,
	getCollectList,
	getProductList,
	getShareQrcode,
} from '@/api/insurance/product'
import draggable from 'vuedraggable'
import {getMyChannelSettleInfo} from '@/api/insurance/settlement'
import {getClickCollectOption, getClickCollectSortOption} from '@/const/crud/introjsOption'
import {baosiNewList, categoryNewList, typeList} from '@/const/crud/product/productManage'
import {isFxadminChannel, isMainChannel} from '@/util/channelUtil'
import {getPageId} from '@/util/commonUtils'
import {currentYYYYmmdd} from '@/util/date'
import {dataURLtoBlob, downloadExportFile} from '@/util/exportFile'
import {toInsureCenter} from '@/util/insureUtils'
import {getStore, removeStore, setStore} from '@/util/store'
import {handleDownCategoryFile} from '@/util/util'
import InsureBeginHint from '@/views/insurance/product/insureBeginHint.vue'
import rrlog from '@meibao/traceback-record'
import introJs from 'intro.js'
import {InsureNotices} from 'meibao-insure'
import {isJiaDian, isRenBao} from 'meibao-insure/src/util/productUtil'
import {mapGetters} from 'vuex'

export default {
	components: {
		InsureBeginHint,
		InsureNotices,
		draggable,
	},
	name: 'product',
	data() {
		return {
			currentItemData: {},
			productList: [],
			isShowContent: false,
			//提醒
			systemMessage: '',
			isDownLoading: false,
			rrlogEventId: null,
			isInsureLoading: false,
			isShareLoading: false,
			//筛选
			selectDataList: {
				types: [],
				groupIds: [],
				categoryLists: [],
				professions: [],
			},
			selectContentList: [
				{
					key: 'types',
					title: '险种：',
					selectLabelList: typeList,
				},
				{
					key: 'groupIds',
					title: '保司：',
					selectLabelList: baosiNewList,
				},
				{
					key: 'categoryLists',
					title: '行业：',
					selectLabelList: categoryNewList,
				},
			],
			isShowQrCode: false,
			qrCodeUrl: '',

			allDataList: [],
			//收藏功能
			getCollectDataList: [],
			collectLoading: false,
			collectIdList: [],
			introOption: {},
			introJsTimeout: true,
		}
	},
	created() {
		this.initData()
	},
	activated() {},
	deactivated() {
		//关闭提醒
		this.introJsTimeout = false
	},
	beforeDestroy() {
		//关闭提醒
		this.introJsTimeout = false
	},
	mounted() {},
	watch: {
		getAllProductList: {
			handler(newVal = [], oldVal) {
				console.log('监听产品库', newVal, oldVal)
				this.allDataList = this.deepClone(newVal)
			},
			deep: true,
			immediate: true,
		},
	},
	//声明周期
	computed: {
		...mapGetters(['userInfo']),
		getAllProductList() {
			//顶部筛选
			let {types = [], groupIds = [], categoryLists = [], professions = []} = this.selectDataList
			let dataList = this.productList.filter(({type = '', groupId = 0, categoryList = '', profession = ''}) => {
				//categoryLists里的每个元素，都包含在categoryList里
				let isType =
					types.length === 0 ||
					(type !== '' && types.findIndex((itemType) => type.split(',').includes(itemType + '')) !== -1)
				let isCategoryList = categoryLists.every((item) => categoryList.includes(item))
				return isType && isCategoryList && (groupIds.length === 0 || groupIds.includes(groupId))
			})
			if (dataList.length <= 0) {
				return []
			}
			//收藏
			if (this.collectIdList.length <= 0) {
				return [
					{
						type: '0',
						dataList,
					},
				]
			}
			//拆分
			let collectList = []
			let collectNoList = []

			for (let collectIdListElement of this.collectIdList) {
				let tempData = dataList.find(({systemId = ''}) => systemId === collectIdListElement)
				if (tempData) {
					collectList.push(tempData)
				}
			}
			for (let tempListElement of dataList) {
				let {systemId} = tempListElement
				if (!this.collectIdList.includes(systemId)) {
					collectNoList.push(tempListElement)
				}
			}
			//1是收藏，2是剩下的产品
			return [
				{type: '1', dataList: collectList},
				{type: '0', dataList: collectNoList},
			]
		},
		isShowTitle() {
			if (this.allDataList.length > 1) {
				let tempIndex = this.allDataList.findIndex(({dataList = []}) => dataList.length === 0)
				if (tempIndex === -1) {
					return true
				}
			}
			return false
		},
	},
	methods: {
		isMainChannel,
		isRenBao,
		isFxadminChannel,
		async initData() {
			let response = (await Promise.all([getProductList(), getCollectList()])) || []
			if (response.length !== 2) {
				throw new Error('获取数据失败')
			}
			let {code: code1, data: data1 = [], msg1} = response[0].data || {}
			let {code: code2, data: data2 = []} = response[1].data || {}
			if (code1 !== 0 || code2 !== 0) {
				throw new Error('获取数据失败')
			}
			this.systemMessage = msg1
			if (isMainChannel()) {
				//获取费率
				await this.onGetBasicFee(data1)
			}
			this.productList = data1
			this.collectIdList = data2
			this.isShowContent = true

			//显示收藏提醒
			this.isShowCollectHint()
		},
		// 去投保
		handleInsure(itemData) {
			//保存数据
			this.currentItemData = itemData
			let {id: productId, title} = itemData
			this.rrlogEventId = rrlog.capture(
				`去投保`,
				{
					productId,
					productName: title,
				},
				{
					sign: true,
				},
			)
			//产品中心
			this.onShowHint()
		},
		handleView(itemData) {
			let {id: productId, insureType, productIdCenter = ''} = itemData
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/insuranceCenter/detailsCenter/${insureType}`,
				}),
				query: {
					productId,
					productIdCenter,
				},
			})
		},
		//去投保
		onGoInsure() {
			let pageId = getPageId()
			if (this.rrlogEventId) {
				setStore({name: `rrlog_eventid_${pageId}`, content: this.rrlogEventId, type: 'session'})
			}
			let {id: productId, productIdCenter = '', insureType} = this.currentItemData
			//跳转投保页面
			toInsureCenter({
				act: `new`,
				pageId,
				productId: productIdCenter,
				insureType,
				sourceProductId: productId,
			})
		},
		onDownloadCategory({id: productId, insureType}) {
			if (this.isDownLoading) {
				this.$message.info('下载职业类别表...')
				return
			}
			if (isJiaDian(insureType)) {
				this.$message.error('无职业类别表！')
				return
			}
			this.isDownLoading = true
			let fileName = `tk_${productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(`/dist/distInsure/categoryDownloadDetail/${productId}`, {}, fileName)
				.then(() => {
					//下载成功
					this.$message.success('下载成功')
				})
				.catch(() => {})
				.finally(() => {
					this.isDownLoading = false
				})
		},
		onCreatePlan({id: productId, insureType, productIdCenter = ''}) {
			if (isJiaDian(insureType)) {
				this.$message.error('该产品计划书紧急开发中..')
				return
			}
			this.$router.push({
				path: this.$router.$avueRouter.getPath({
					src: `/plan/planInsure`,
				}),
				query: {
					productId,
					productIdCenter,
					insureType,
				},
			})
		},
		async onShowHint() {
			let {id: sourceProductId, productIdCenter: productId} = this.currentItemData
			this.isInsureLoading = true
			await this.$refs.refInsureNotices.onGetHintInfoData({productId, sourceProductId})
			this.isInsureLoading = false

			// this.isInsureLoading = true
			// try {
			//   let tempData = await getInsureHint({productId, sourceProductId})
			//   let {code = -1, data = {}, msg} = tempData.data || {}
			//   if (code === 0) {
			//     let {hintInfo = {}} = data
			//     this.$refs.refInsureNotices.onShowNotices(hintInfo)
			//   } else {
			//     this.$message.error(msg)
			//   }
			// } catch (e) { } finally {
			//   this.isInsureLoading = false
			// }
		},
		//去转发
		onToTransmit(itemData) {
			this.isShareLoading = true
			getShareQrcode(itemData)
				.then((codeData = '') => {
					this.qrCodeUrl = `data:image/png;base64,${codeData}`
					this.isShowQrCode = true
				})
				.catch(() => {})
				.finally(() => {
					this.isShareLoading = false
				})
		},
		onSaveWxMa() {
			downloadExportFile(dataURLtoBlob(this.qrCodeUrl), '录单_小程序二维码', 'png')
		},
		//加基础费率
		async onGetBasicFee(productList = []) {
			let settleRes = (await getMyChannelSettleInfo()) || {}
			let {code: code1, data: {ruleBasic = {}} = {}} = settleRes.data || {}
			if (code1 !== 0) {
				return
			}
			let {ruleItems = []} = ruleBasic
			if (ruleItems.length > 0) {
				//过滤掉失效的
				ruleItems = ruleItems.filter(
					({effectiveTime, expireTime}) =>
						Date.now() >= new Date(effectiveTime).getTime() && Date.now() <= new Date(expireTime).getTime(),
				)
				//存在结算
				productList.forEach((itemData) => {
					let {insureType, title, id} = itemData
					//先判断当前这个产品有没有ID匹配到的，如果有则只用匹配到的数据
					let tempRules = ruleItems.filter(
						({insureType: insureTypeRule, productIds = []}) =>
							insureTypeRule === insureType && productIds.length > 0 && productIds.includes(parseInt(id)),
					)
					if (tempRules.length <= 0) {
						//没找到了，则继续查找
						tempRules = ruleItems.filter(
							({insureType: insureTypeRule, effectiveTime, expireTime, productIds = []}) =>
								insureTypeRule === insureType && (productIds.length === 0 || productIds.includes(parseInt(id))),
						)
					}
					let feeContent = 0
					let feeContentList = []
					if (tempRules.length > 0) {
						if (tempRules.length === 1) {
							feeContent = tempRules[0].basicFeeRate
							feeContentList.push({label: title, value: feeContent / 100 + '%'})
						} else {
							for (let i = 0; i < tempRules.length; i++) {
								let {basicFeeRate = 0} = tempRules[i]
								if (feeContent < basicFeeRate) {
									feeContent = basicFeeRate
								}
								feeContentList.push({label: `${title}-${i + 1}档`, value: basicFeeRate / 100 + '%'})
							}
						}
					}
					if (feeContent > 0) {
						itemData.feeContent = `${feeContent / 100}%`
					}
					itemData.feeContentList = feeContentList
				})
			}
		},
		//展示结算
		onShowFeeDetail({feeContentList}) {},
		//获取收藏样式 1：收藏 0：全部
		getCollectIconStyle(type) {
			if (this.collectLoading) {
				return ['el-icon-loading', {fontSize: '21px', padding: '10px'}]
			}
			return type === '1'
				? ['el-icon-star-on', {fontSize: '26px', padding: '6px', color: 'red'}]
				: ['el-icon-star-off', {fontSize: '21px', padding: '10px'}]
		},
		//收藏
		async onCollect({systemId}) {
			try {
				this.collectLoading = true
				let res = (await collectProduct(systemId).catch(() => {})) || {}
				let {code = -1} = res.data || {}
				if (code !== 0) {
					return
				}
				//获取收藏列表
				let resList = (await getCollectList().catch(() => {})) || {}
				let {code: codeList = -1, data: dataList = []} = resList.data || {}
				if (codeList !== 0) {
					return
				}
				//判断是否为新增的收藏，如果是则恢复收藏排序提醒
				if (dataList.length > 0 && this.collectIdList.length === 0) {
					removeStore({name: 'isShowCollectHint'})
				}
				this.collectIdList = dataList
				this.$message.success('操作成功！')
			} finally {
				this.collectLoading = false
			}
		},
		//是否展示提醒
		isShowCollectHint() {
			let lastHintTime = getStore({name: 'isShowCollectHint'}) || 0
			let tempTime = process.env.NODE_ENV === 'development' ? 60 * 60 * 1000 : 48 * 60 * 60 * 1000
			//禁止滚动元素
			let avueView = document.getElementById('avue-view')
			if (Date.now() - lastHintTime > tempTime && this.productList.length > 5) {
				avueView.style.overflow = 'hidden'
				//配置项
				let tempOption = this.collectIdList.length <= 0 ? getClickCollectOption() : getClickCollectSortOption()
				setTimeout(() => {
					if (this.introJsTimeout) {
						introJs().setOptions(tempOption).start()
						setStore({
							name: 'isShowCollectHint',
							content: Date.now(),
						})
					}
					avueView.style.overflow = 'hidden auto'
				}, 1500)
			}
		},
		//开始拖拽事件
		onStart(data) {},
		//拖拽结束事件
		onEnd(data) {
			let {newIndex, oldIndex} = data
			if (newIndex !== oldIndex) {
				//收藏数据
				let {dataList = []} = this.allDataList.find(({type}) => type === '1') || {}
				if (dataList.length > 0) {
					//调整顺序，如果长度小于newindex,或者oldindex,
					if (dataList.length < newIndex || dataList.length < oldIndex) {
						this.$message.error('数据错误，请重新拖拽！')
						return
					}
					let tempData = dataList[oldIndex]
					dataList.splice(oldIndex, 1)
					dataList.splice(newIndex, 0, tempData)
					//发起请求
					collectProductSort(dataList.map(({systemId}) => systemId).join(','))
						.then(() => {})
						.catch(() => {})
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.ul,
li {
	list-style-type: none;
}

.flex-container {
	/* We first create a flex layout context */
	display: flex;
	/* Then we define the flow direction
      and if we allow the items to wrap
  * Remember this is the same as:
  * flex-direction: row;
  * flex-wrap: wrap;
  */
	flex-flow: row wrap;
	/* Then we define how is distributed the remaining space */
	justify-content: space-around;

	padding: 10px;
	margin: 0;
	list-style: none;
}

/* .flex-item {
    padding: 5px;
    width: 320;
    height: 400px;
    margin-top: 10px;
    line-height: 400px;
    color: white;
    font-weight: bold;
    font-size: 3em;
    text-align: center;
} */

.title-shu {
	width: 6px;
	height: 35px;
	background-color: #1890ff;
}

.select_content {
	width: 100%;
	height: auto;
	background-color: #f7f8fa;
	border-radius: 8px;
	padding: 5px 10px;
	box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

	&_item_row {
		&_title {
			font-size: 0.85em;
			color: #333333;
			font-weight: bold;
			display: inline-block;
			width: 80px;
			min-width: 80px;
			margin-bottom: 1px;
		}

		&:not(:last-child) {
			margin-bottom: 6px;
		}
	}

	&_item_row_margin {
		margin-bottom: 0 !important;
	}

	&_hide_btn {
		&:hover {
			cursor: pointer;
			scale: 1.1;
			font-weight: bold;
		}

		&_icon {
			color: #409eff;
			transform: rotate(-90deg);
			transition: 0.3s;
		}

		&_icon_shou {
			transform: rotate(90deg);
			transition: 0.3s;
		}
	}

	&_hide {
		overflow: hidden;
		max-height: 0;
		transition: 0.5s;
	}
}

.product_content {
	&_item {
		width: 220px;
		font-size: 0.85em;
		margin-top: 20px;
		position: relative;

		&:hover {
			scale: 1.02;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		}

		&_img {
			width: 100%;
			height: 128px;
			display: block;
		}

		&_collect {
			cursor: pointer;
			position: absolute;
			top: 0;
			right: 0;
		}

		&_control {
			height: 35px;
			background-color: #f0f0f0;
		}

		&_text {
			font-size: 0.9em;
			cursor: pointer;

			&:hover {
				scale: 1.05;
				font-weight: bold;
			}
		}

		&_des {
			height: 85px;
			padding: 10px;

			&_content {
				font-size: 0.7em;
				color: #333333;
			}
		}

		&_fee {
			padding: 5px 10px;
			height: 25px;
			width: 140px;
			overflow: hidden;
			color: #409eff;
			cursor: pointer;
		}

		&_insure {
			padding: 0 10px;

			&_price {
				font-size: 22px;

				&::before {
					content: '¥';
					font-size: 16px;
				}

				&::after {
					content: ' 起';
					font-size: 16px;
				}
			}

			&_to {
				font-size: 12px;
				border-radius: 50px;
				padding: 6px 12px;

				&:hover {
					font-weight: bold;
					scale: 1.05;
				}
			}
		}
	}
}

.el-icon-download .el-icon-notebook-2 {
	font-size: 14px;

	//&::before {
	//  color: red !important;
	//}
}

::v-deep .el-checkbox__inner {
	height: 16px;
	width: 16px;

	&::after {
		height: 7px;
		left: 4px;
	}
}

::v-deep .el-checkbox__label {
	font-size: 0.9em;
}

::v-deep .el-card {
	box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06);
}

::v-deep .share_dialog {
	background: transparent url('../../../../../public/images/bg_share.jpg') no-repeat center center;
	height: 620px;
	background-size: 100% 100%;
}

::v-deep .el-icon-close:before {
	font-size: 25px;
	border: 1px solid rgba(134, 133, 133, 0.75);
	border-radius: 50%;
	padding: 5px;
	background: gainsboro;
}

::v-deep .el-icon-arrow-right:before {
	background: rgb(64, 158, 255);
	border-radius: 50%;
	padding: 2px;
	color: white;
	font-size: 10px;
}
</style>
